/**
 * Utilitaires numériques du moteur d'animation de la vitrine.
 * Port verbatim de maquette:4159-4161 (prototype-landing-v3.html).
 */

/** Ramène `v` dans l'intervalle [a, b] (par défaut [0, 1]). */
export function clamp(v: number, a = 0, b = 1): number {
	return Math.min(b, Math.max(a, v));
}

/** Interpolation de phase : position de `p` entre `a` et `b`, clampée dans [0, 1]. */
export function ph(p: number, a: number, b: number): number {
	return clamp((p - a) / (b - a));
}

/** Easing cubique out : 1 - (1 - t)^3. */
export function ease(t: number): number {
	return 1 - Math.pow(1 - t, 3);
}
